var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 721.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3742ac;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M498.57,443.64c-4.9-77.59-40.55-134.47-111.85-248.24C291.53,43.53,231.86,17.01,196.67,7.22,181.14,2.91,166.99.9,155.32.02c-5.93-.45-9.66,6.17-6.34,11.1,4.06,6.02,8.07,13.34,11.11,21.96,22.57,63.99-31.18,134.43-56.75,173.16C45.28,294.22-34.2,471.36,15.81,586.36c37.36,85.89,145.43,133.63,236.26,134.88,22.25.31,121.43,1.67,191.01-75.27,63.98-70.75,58.08-161.06,55.48-202.32ZM95.1,600.84c-65.97-84.38-42.43-225.97,12.46-251.17,25.93-11.9,68.14-2.1,75.6,17.09,4.13,10.64-3.4,21.62-10.52,34.18-6.04,10.65-54.09,97.49-33.05,159.82,4.13,12.25,15.09,26.33,37,54.48,18.81,24.17,36.45,42.65,49.3,55.22-21.92-2.97-87.89-14.76-130.78-69.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpIcon);
export default __webpack_public_path__ + "static/media/pp-icon.3c82b503f8a0f46197c63b02021957f4.svg";
export { ForwardRef as ReactComponent };